export default function importAllSvgIcons() {
try {
  const request: __WebpackModuleApi.RequireContext = require.context('../../assets/svg', false, /\.svg$/)
    const keys = request.keys() as Array<any>
    keys.forEach(request)
} catch (error) {
    throw new Error('svg icon loading fail')
}
  
}